@if (mode() == 'search') {
    <z-table-vs-search
        #ZTableVSSearch
        [lazy]="true"
        [lazyLoadOnInit]="false"
        [activeRowIndex]="index"
        [disabled]="disabled ?? false"
        [options]="options()"
        [existingIds]="existingIds()"
        [inputText]="model"
        [doNotExpandOptionsOnInputFocus]="doNotExpandOptionsOnInputFocus()"
        [dataTableSchema]="dataTableSchema()"
        [totalRecords]="totalRecords()"
        [rowDataSelect]="selectedOption()"
        [ngModelOptions]="{ standalone: true }"
        [searchable]="true"
        [scrollHeight]="scrollHeight()"
        [(ngModel)]="model"
        (ngModelChange)="onNgModelChange($event)"
        (searchTermChange)="searchTermChange($event)"
        (inputFocus)="onInputFocus()"
        (inputBlur)="onInputBlur()"
        (lazyLoad)="onLazyLoad($event)"
        (rowDataSelectChange)="onRowDataSelect($event)"
    ></z-table-vs-search>
}
@if (mode() == 'edit' || mode() == 'lockedit') {
    <div class="flex flex-row gap-2">
        <!-- [{{ model }} / {{ productPackageId() }}] -->
        <z-table-vs-select
            [lazy]="true"
            [lazyLoadOnInit]="true"
            [activeRowIndex]="index"
            [disabled]="disabled ?? false"
            [options]="options()"
            [inputText]="model"
            [rows]="10"
            [showLabel]="false"
            [existingIds]="existingIds()"
            [doNotExpandOptionsOnInputFocus]="doNotExpandOptionsOnInputFocus()"
            [dataTableSchema]="dataTableSchema()"
            [totalRecords]="totalRecords()"
            [rowDataSelect]="selectedOption()"
            [ngModelOptions]="{ standalone: true }"
            [searchable]="inputMode() == 'code'"
            [stateKey]="'products-select'"
            [(ngModel)]="model"
            (ngModelChange)="onNgModelChange($event)"
            (searchTermChange)="searchTermChange($event)"
            (inputFocus)="onInputFocus()"
            (inputBlur)="onInputBlur()"
            (lazyLoad)="onLazyLoad($event)"
            (inputDblClick)="onInputDblClick()"
            (rowDataSelectChange)="onRowDataSelect($event)"
            (resetTable)="onResetTable()"
        >
            <ng-template #selectedItem let-selectedRow>
                <span style="white-space: nowrap">
                    <!-- Αν έχει επιλεγεί κάτι από την αποθήκη (είδος ή υπηρεσία) -->
                    @if (productPackageId() != undefined) {
                        @if (kind() == 'S') {
                            <i
                                class="pi pi-car ml-2"
                                style="color: var(--primary-color)"
                                title="Επιλεγμένη Υπηρεσία"
                            ></i>
                            &nbsp;
                        }
                        @if (kind() == 'M') {
                            <i
                                class="pi pi-warehouse ml-2"
                                style="color: var(--primary-color)"
                                title="Είδος επιλεγμένο από την αποθήκη"
                            ></i>
                            &nbsp;
                        }
                    }
                    {{ selectedRow.Code }}
                </span>
                <!-- {{ selectedRow | zContactPrimaryPhone }} -->
            </ng-template>

            <!-- <ng-template #tableRowHeader let-columns="columns">
            <th>Επωνυμία</th>
            <th>Όνομα</th>
            <th>Τηλέφωνο</th>
            <th>Διεύθυνση</th>
            <th>Νομική Μορφή</th>
        </ng-template>

        <ng-template
            #tableRow
            let-rowData
            let-columns="columns"
            let-index="index"
        >
            <td>{{ rowData?.SureName }}</td>
            <td>{{ rowData?.FIrstNameRaw ?? rowData?.FirstName.Name }}</td>
            <td>{{ rowData | zContactPrimaryPhone }}</td>
            <td>
                {{ rowData | zCustomerPrimaryContactAddress: true }}
            </td>
            <td>{{ rowData | zCustomerLegalType }}</td>
        </ng-template>
         -->
        </z-table-vs-select>

        <!-- <p-button icon="pi pi-plus" severity="success" />
        <p-button icon="pi pi-pencil" severity="warn" /> -->
    </div>
}
<!-- {{ productPackageId() }} -->
@if (mode() == 'view') {
    <div class="flex flex-row grow gap-2 items-start">
        @if (model) {
            <span class="flex flex-auto">{{ model }}</span>
        } @else {
            <input
                type="text"
                pInputText
                title="Καταχωρήστε τον Κωδικό του Είδους ή της Υπηρεσίας που θέλετε."
                placeHolder="Κωδικός Είδους / Υπηρεσίας"
                readonly="readonly"
                style="width: 140px"
            />
        }
        <!-- @if (productPackageId() == undefined) {
            <p-button
                title="Ο κωδικός δεν είναι καταχωρήμενος στη βάση σας. Πατήστε εδώ για να καταχωρήσετε το κωδικό και το προϊόν για μελλοντική χρήση"
                [text]="true"
                class="flex"
                icon="pi pi-plus"
                severity="success"
                size="small"
                (onClick)="appendNewProductPackage($event)"
            />
        } -->
        @if (productPackageId() != undefined) {
            <p-button
                title=" Πατήστε εδώ για να μεταβάλετε τα στοιχεία του προϊόντος / υπηρεσίας"
                [text]="true"
                class="flex"
                icon="pi pi-pencil"
                severity="success"
                size="small"
                (onClick)="editProductPackage($event)"
            />
        }
    </div>
}

<p-dialog
    [(visible)]="productVisibleDialog"
    [maximizable]="false"
    [modal]="true"
    [closable]="true"
    [closeOnEscape]="false"
    [focusOnShow]="false"
    [resizable]="true"
    [appendTo]="'body'"
    [style]="{ height: '90vh', width: '1100px' }"
>
    <ng-template #header>
        <div class="inline-flex items-center justify-center gap-2">
            <span class="font-bold whitespace-nowrap">
                @switch (productDialogMode) {
                    @case ('add') {
                        Καρτέλα Νέου Προϊόντος / Υπηρεσίας
                    }
                    @case ('edit') {
                        Μεταβολή Προϊόντος / Υπηρεσίας
                    }
                }
            </span>
        </div>
    </ng-template>
    <!--  <app-customer-form #customerFormComponent-->
    <!--                     [selectedCustomer]="selectedProduct"-->
    <!--  ></app-customer-form>-->
    @if (productVisibleDialog) {
        <!-- <app-product-form
      #productPackageFormComponent
      [fetchDataForEditById]="fetchDataForEditById()"
    >
    </app-product-form> -->
        <z-product-edit
            #productEditComponent
            [productDialogMode]="productDialogMode"
            [productPackageId]="productPackageId()"
        >
        </z-product-edit>
    }
    <ng-template #footer>
        <!--    <p-button-->
        <!--      (click)="visibleDialog = false"-->
        <!--      [text]="true"-->
        <!--      label="Cancel"-->
        <!--      severity="secondary"-->
        <!--    />-->
        <p-button
            (onClick)="saveProductPackage()"
            label="Αποθήκευση"
            severity="primary"
            [disabled]="productEditComponent?.formGroup?.valid != true"
        />
    </ng-template>
</p-dialog>
